// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".value-field{float:left;margin-right:15px}.flex-field{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-field .v-input-group{-webkit-box-flex:inherit;-ms-flex:inherit;flex:inherit;width:110px}.flex-field .v-input-group .label{overflow:initial;top:20px}", ""]);
// Exports
module.exports = exports;
